// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file suppliers/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { TaxIdentifier } from "../auth/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.Supplier
 */
export class Supplier extends Message<Supplier> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: com.neulink.pharmacy.SupplierMetadata metadata = 4;
   */
  metadata?: SupplierMetadata;

  /**
   * @generated from field: com.neulink.pharmacy.SupplierCreditTerms credit_terms = 5;
   */
  creditTerms?: SupplierCreditTerms;

  constructor(data?: PartialMessage<Supplier>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.Supplier";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "metadata", kind: "message", T: SupplierMetadata },
    { no: 5, name: "credit_terms", kind: "message", T: SupplierCreditTerms },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Supplier {
    return new Supplier().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Supplier {
    return new Supplier().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Supplier {
    return new Supplier().fromJsonString(jsonString, options);
  }

  static equals(a: Supplier | PlainMessage<Supplier> | undefined, b: Supplier | PlainMessage<Supplier> | undefined): boolean {
    return proto3.util.equals(Supplier, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SupplierMetadata
 */
export class SupplierMetadata extends Message<SupplierMetadata> {
  /**
   * @generated from field: string phone_number = 1;
   */
  phoneNumber = "";

  /**
   * @generated from field: string contact_person_name = 2;
   */
  contactPersonName = "";

  /**
   * @generated from field: string country = 3;
   */
  country = "";

  /**
   * @generated from field: string city = 4;
   */
  city = "";

  /**
   * Needed for IN for GST
   *
   * @generated from field: string state = 5;
   */
  state = "";

  /**
   * Is this supplier a SEZ (Special Economic Zone) supplier
   *
   * @generated from field: bool is_sez = 6;
   */
  isSez = false;

  /**
   * Tax identifier for the supplier
   *
   * @generated from field: com.neulink.pharmacy.TaxIdentifier tax_identifier = 7;
   */
  taxIdentifier?: TaxIdentifier;

  constructor(data?: PartialMessage<SupplierMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SupplierMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contact_person_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_sez", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "tax_identifier", kind: "message", T: TaxIdentifier },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupplierMetadata {
    return new SupplierMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupplierMetadata {
    return new SupplierMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupplierMetadata {
    return new SupplierMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: SupplierMetadata | PlainMessage<SupplierMetadata> | undefined, b: SupplierMetadata | PlainMessage<SupplierMetadata> | undefined): boolean {
    return proto3.util.equals(SupplierMetadata, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SupplierCreditTerms
 */
export class SupplierCreditTerms extends Message<SupplierCreditTerms> {
  /**
   * Credit period in days
   *
   * @generated from field: int32 credit_period = 1;
   */
  creditPeriod = 0;

  /**
   * Is credit allowed for this supplier
   *
   * @generated from field: bool is_credit_allowed = 2;
   */
  isCreditAllowed = false;

  /**
   * Day of the month when payments are due
   *
   * @generated from field: int32 monthly_payment_day = 3;
   */
  monthlyPaymentDay = 0;

  constructor(data?: PartialMessage<SupplierCreditTerms>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SupplierCreditTerms";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credit_period", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "is_credit_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "monthly_payment_day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupplierCreditTerms {
    return new SupplierCreditTerms().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupplierCreditTerms {
    return new SupplierCreditTerms().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupplierCreditTerms {
    return new SupplierCreditTerms().fromJsonString(jsonString, options);
  }

  static equals(a: SupplierCreditTerms | PlainMessage<SupplierCreditTerms> | undefined, b: SupplierCreditTerms | PlainMessage<SupplierCreditTerms> | undefined): boolean {
    return proto3.util.equals(SupplierCreditTerms, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SupplierLifetimeStats
 */
export class SupplierLifetimeStats extends Message<SupplierLifetimeStats> {
  /**
   * Total available quantity of items from this supplier
   *
   * @generated from field: float available_quantity = 1;
   */
  availableQuantity = 0;

  /**
   * Total expired quantity of items from this supplier
   *
   * @generated from field: float expired_quantity = 2;
   */
  expiredQuantity = 0;

  /**
   * Total out of stock quantity of items from this supplier
   *
   * @generated from field: float out_of_stock_quantity = 3;
   */
  outOfStockQuantity = 0;

  /**
   * Total number of purchase orders from this supplier
   *
   * @generated from field: int32 total_purchase_orders = 4;
   */
  totalPurchaseOrders = 0;

  /**
   * Total number of purchase invoices from this supplier
   *
   * @generated from field: int32 total_purchase_invoices = 5;
   */
  totalPurchaseInvoices = 0;

  /**
   * Total capitalization of goods from this supplier
   *
   * @generated from field: float total_capitalization_of_goods = 6;
   */
  totalCapitalizationOfGoods = 0;

  /**
   * Total number of purchase returns from this supplier
   *
   * @generated from field: int32 total_purchase_returns = 7;
   */
  totalPurchaseReturns = 0;

  /**
   * Total number of upcoming payments to this supplier
   *
   * @generated from field: int32 total_upcoming_payments = 8;
   */
  totalUpcomingPayments = 0;

  /**
   * Total number of payments made to this supplier
   *
   * @generated from field: int32 total_payments_made = 9;
   */
  totalPaymentsMade = 0;

  /**
   * Total value of payments made to this supplier
   *
   * @generated from field: float total_value_of_payments_made = 10;
   */
  totalValueOfPaymentsMade = 0;

  constructor(data?: PartialMessage<SupplierLifetimeStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SupplierLifetimeStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "available_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "expired_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "out_of_stock_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_purchase_orders", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_purchase_invoices", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_capitalization_of_goods", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "total_purchase_returns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "total_upcoming_payments", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "total_payments_made", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "total_value_of_payments_made", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupplierLifetimeStats {
    return new SupplierLifetimeStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupplierLifetimeStats {
    return new SupplierLifetimeStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupplierLifetimeStats {
    return new SupplierLifetimeStats().fromJsonString(jsonString, options);
  }

  static equals(a: SupplierLifetimeStats | PlainMessage<SupplierLifetimeStats> | undefined, b: SupplierLifetimeStats | PlainMessage<SupplierLifetimeStats> | undefined): boolean {
    return proto3.util.equals(SupplierLifetimeStats, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SupplierPayouts
 */
export class SupplierPayouts extends Message<SupplierPayouts> {
  /**
   * ID of the purchase invoice associated with the payout
   *
   * @generated from field: string purchase_invoice_id = 1;
   */
  purchaseInvoiceId = "";

  /**
   * Number of the purchase invoice associated with the payout
   *
   * @generated from field: string purchase_invoice_number = 2;
   */
  purchaseInvoiceNumber = "";

  /**
   * ID of the purchase order associated with the payout
   *
   * @generated from field: string purchase_order_id = 3;
   */
  purchaseOrderId = "";

  /**
   * Number of the purchase order associated with the payout
   *
   * @generated from field: string purchase_order_number = 4;
   */
  purchaseOrderNumber = "";

  /**
   * Invoice number for the payout
   *
   * @generated from field: string invoice_number = 5;
   */
  invoiceNumber = "";

  /**
   * Date of the invoice for the payout
   *
   * @generated from field: google.protobuf.Timestamp invoice_date = 6;
   */
  invoiceDate?: Timestamp;

  /**
   * Due date for the payout
   *
   * @generated from field: google.protobuf.Timestamp due_date = 7;
   */
  dueDate?: Timestamp;

  /**
   * Amount of the payout
   *
   * @generated from field: float amount_to_be_paid = 8;
   */
  amountToBePaid = 0;

  /**
   * Amount that has been paid
   *
   * @generated from field: float amount_paid = 9;
   */
  amountPaid = 0;

  /**
   * Amount that is still due
   *
   * @generated from field: float amount_due = 10;
   */
  amountDue = 0;

  constructor(data?: PartialMessage<SupplierPayouts>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SupplierPayouts";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "purchase_invoice_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "invoice_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "invoice_date", kind: "message", T: Timestamp },
    { no: 7, name: "due_date", kind: "message", T: Timestamp },
    { no: 8, name: "amount_to_be_paid", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "amount_paid", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "amount_due", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupplierPayouts {
    return new SupplierPayouts().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupplierPayouts {
    return new SupplierPayouts().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupplierPayouts {
    return new SupplierPayouts().fromJsonString(jsonString, options);
  }

  static equals(a: SupplierPayouts | PlainMessage<SupplierPayouts> | undefined, b: SupplierPayouts | PlainMessage<SupplierPayouts> | undefined): boolean {
    return proto3.util.equals(SupplierPayouts, a, b);
  }
}

